import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { DispatchRulesService } from '../admin/ngc/dispatch-rules/dispatch-rules.service';

/**
 * Keeps the dispatch rules page from rendering for a user the dispatcher would
 * refuse anyway.
 *
 * This is deliberately not `AdminGuard`. Site admin is necessary but not
 * sufficient: the dispatcher also gates on an email allow list it is deployed
 * with, so the only client that can answer "may this user see the rules" is the
 * dispatcher. The guard asks it and takes the answer.
 *
 * A refused user lands on the root, the same place `AdminGuard` sends one.
 */
export const dispatchRulesVisibleGuard: CanActivateFn = () => {
  const dispatchRules = inject(DispatchRulesService);
  const router = inject(Router);

  return dispatchRules.isVisible().pipe(map((visible) => visible || router.parseUrl('/')));
};
